import React from 'react';
import {View} from 'react-native';
import {Modal, ScrollView, Text} from 'react-native';
import {styles} from './styles';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';

const EquipmentTermsModal = ({
  termsVisible,
  setTermsVisible,
  type,
  decision,
}: any) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={termsVisible}
      onRequestClose={() => setTermsVisible(false)}>
      <View style={styles.modalOverlay}>
        <View style={styles.modalContent}>
          <ScrollView>
            <Text style={styles.modalTitle}>
              Termos de uso de aluguel de equipamentos
            </Text>
            <Text style={styles.modalText}>
              As geladeiras fornecidas pela Brasal Refrigerantes devem ser
              utilizadas apenas para armazenagem de produtos fornecidos pela
              mesma;
              {'\n\n'}- Nossas geladeiras possuem sistema de economia de
              energia, ou seja, à noite entram em modo de repouso;
              {'\n\n'}- É importante que nossos clientes façam compras regulares
              para mantermos a geladeira no ponto de venda;
              {'\n\n'}- Caso o ponto de venda tenha alguma dificuldade em
              realizar o pedido, recomendamos no mínimo uma compra mensal;
              {'\n\n'}- Os equipamentos instalados no ponto de venda não devem
              ser transferidos para outro endereço. Caso haja necessidade, favor
              acionar o vendedor para que uma equipe da Brasal especializada
              faça o transporte dos equipamentos;
              {'\n\n'}- Os equipamentos são um benefício que a Brasal oferece
              aos seus parceiros. Trata-se de um investimento alto, por isso
              pedimos que cuide e preserve da melhor forma, garantindo o bom
              funcionamento e durabilidade dos ativos;
              {'\n\n'}- Caso tenha alguma dificuldade de contato com nosso
              vendedor ou caso seu equipamento apresente alguma falha técnica,
              por favor acione nosso time através do 0800 061 5000.
            </Text>
            {type == 1 && (
              <ButtonComponent
                title="Fechar"
                onPress={() => setTermsVisible(false)}
                width="100%"
              />
            )}
            {type == 2 && (
              <View style={styles.rowButtons}>
                <View style={styles.buttonHalf}>
                  <ButtonComponent
                    title="Recusar"
                    onPress={() => {
                      if (!!decision) {
                        decision(false);
                      }
                      setTermsVisible(false);
                    }}
                    width="100%"
                  />
                </View>
                <View style={styles.buttonHalf}>
                  <ButtonComponent
                    title="Concordar"
                    onPress={() => {
                      if (!!decision) {
                        decision(true);
                      }
                      setTermsVisible(false);
                    }}
                    width="100%"
                    backgroundColor="#28a745"
                  />
                </View>
              </View>
            )}
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

export default EquipmentTermsModal;
